import EntertainmentMobile from '../assets/banners/entertainment_mobile.png';
import HealthMobile from '../assets/banners/health_mobile.png';
import NewsMobile from '../assets/banners/news_mobile.png';
import SportsMobile from '../assets/banners/sports_mobile.png';
import Entertainment from '../assets/banners/entertainment.png';
import Health from '../assets/banners/health.png';
import News from '../assets/banners/news.png';
import Sports from '../assets/banners/sports.png';

import EntertainmentMobileId from '../assets/banners/entertainment_mobile_id.png';
import HealthMobileId from '../assets/banners/health_mobile_id.png';
import NewsMobileId from '../assets/banners/news_mobile_id.png';
import SportsMobileId from '../assets/banners/sports_mobile_id.png';
import EntertainmentId from '../assets/banners/entertainment_id.png';
import HealthId from '../assets/banners/health_id.png';
import NewsId from '../assets/banners/news_id.png';
import SportsId from '../assets/banners/sports_id.png';
import { config } from '../constants/domainConfig';

export default function getBanners() {
    return config.lang === 'id' ? [
        { bannerLg: EntertainmentId, bannerSm: EntertainmentMobileId, name: 'Entertainment' },
        { bannerLg: HealthId, bannerSm: HealthMobileId, name: 'Health & Lifestyle' },
        { bannerLg: NewsId, bannerSm: NewsMobileId, name: 'News' },
        { bannerLg: SportsId, bannerSm: SportsMobileId, name: 'Sports' },
    ] : [
        { bannerLg: Entertainment, bannerSm: EntertainmentMobile, name: 'Entertainment' },
        { bannerLg: Health, bannerSm: HealthMobile, name: 'Health & Lifestyle' },
        { bannerLg: News, bannerSm: NewsMobile, name: 'News' },
        { bannerLg: Sports, bannerSm: SportsMobile, name: 'Sports' },
    ];
}
